<script type="ts">
	import { onMount } from 'svelte';
	import Time from 'svelte-time';
	import { get } from 'svelte/store';
	// import Button from '../shared/Button.svelte';
	import { storeSettings } from '../../store/StoreSettings';
	// import EventCourtesyPromotors from './EventCourtesyPromotors.svelte';

	const publicKey = get(storeSettings).publicKey;
	const borderRadius = get(storeSettings).borderRadius;
	// const buttonText = get(storeSettings).buttonText;

	let event: any = [];
	onMount(async () => {
		const res = await fetch(`API_URL/events/next`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				publicKey: publicKey
			}
		});
		event = await res.json();
	});

	// let modal;
</script>

{#if event && event.id}
	<div class="w-full overflow-hidden shadow-lg">
		<div
			class="w-full flex-grow bg-center bg-cover bg-no-repeat sm:hidden"
			style="background-image: url({event.image});"
		/>
		<!-- class="relative w-100 h-64 md-h-80 md:m-4 overflow-hidden bg-gray-100 md:rounded-lg bg-center bg-cover bg-no-repeat hidden sm:block" -->
		<div class="w-full flex-grow sm:block">
			<img src={event.imageCover} alt="" />
		</div>

		<div class="w-full p-4 block  bg-white" class:rounded-lg={borderRadius}>
			<div class="flex items-end flex-col md:flex-row">
				<div class="flex-grow flex ">
					<div class="flex flex-col text-center pr-3 mt-2 ">
						<div class="text-2xl line font-semibold leading-5">
							<Time timestamp={event.startAt} format="DD" />
						</div>
						<div class="text-md font-semibold uppercase leading-5">
							<Time timestamp={event.startAt} format="MMM" />
						</div>
					</div>
					<div class="">
						<h1
							class="font-semibold text-lg md:text-xl inline-block transition duration-500 ease-in-out"
						>
							{event.name}
						</h1>
						<h3 class="font-light opacity-60 text-sm flex items-center">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="16"
								height="16"
								fill="currentColor"
								class="bi bi-clock mr-2"
								viewBox="0 0 16 16"
							>
								<path
									d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
								/>
								<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
							</svg>
							<Time timestamp={event.startAt} format="HH:mm" /> - <Time
								timestamp={event.endAt}
								format="HH:mm"
							/>
						</h3>
						<div class="mt-4 pr-6">
							{@html event.description}
						</div>
					</div>
				</div>
				<!-- <div class="mt-4 w-full md:w-auto flex justify-center items-center md:justify-end">
					<Button on:click={() => modal.show(event)}>{buttonText}</Button>
				</div> -->
			</div>
		</div>
	</div>

	<!-- <EventCourtesyPromotors bind:this={modal} /> -->
{/if}
